module.exports = __webpack_public_path__ + "img/islington_b5.8176f6d7.jpg";